import { fontEntries, fontTheme, urlMap } from '../auto-generated/font-family';
import { AssetsResolveType, SUFFIX_FORMAT_MAP } from './constants';
export const fontFamily = Object.assign({ sans: [
        // 系统字体
        '-apple-system',
        // 英文字体
        'BlinkMacSystemFont',
        'Segoe UI',
        'Helvetica Neue',
        'Helvetica',
        'Arial',
        // Apple 中文字体
        'PingFang SC',
        'Hiragino Sans GB',
        'STHeiti',
        // Android 字体
        'Droid Sans Fallback',
        'Droid Sans',
        // 巨硬字体
        'Microsoft YaHei',
        // 开源字体
        'Source Han Sans SC',
        'Noto Sans CJK SC',
        'WenQuanYi Micro Hei',
        // 非衬线字体
        'sans-serif'
    ] }, fontTheme);
function addFamilyName(obj, familyName) {
    return Object.fromEntries(Object.entries(obj).map(([key, pair]) => [
        key,
        [pair[0], Object.assign(Object.assign({}, pair[1]), { fontFamily: familyName })]
    ]));
}
const UI_FONTS = {
    h8: [
        '32px',
        { lineHeight: '48px' }
    ],
    h7: [
        '30px',
        { lineHeight: '44px' }
    ],
    h6: [
        '28px',
        { lineHeight: '42px' }
    ],
    h5: [
        '26px',
        { lineHeight: '38px' }
    ],
    h4: [
        '24px',
        { lineHeight: '36px' }
    ],
    h3: [
        '22px',
        { lineHeight: '32px' }
    ],
    h2: [
        '20px',
        { lineHeight: '30px' }
    ],
    h1: [
        '18px',
        { lineHeight: '26px' }
    ],
    t2: [
        '16px',
        { lineHeight: '24px' }
    ],
    t1: [
        '14px',
        { lineHeight: '20px' }
    ],
    b2: [
        '14px',
        { lineHeight: '20px' }
    ],
    b1: [
        '13px',
        { lineHeight: '19px' }
    ],
    caption: [
        '12px',
        { lineHeight: '18px' }
    ],
    addition: [
        '10px',
        { lineHeight: '14px' }
    ],
    'support-h7': [
        '24px',
        { lineHeight: '43px', fontWeight: 600 }
    ],
    'support-h6': [
        '22px',
        { lineHeight: '40px', fontWeight: 600 }
    ],
    'support-h5': [
        '20px',
        { lineHeight: '36px', fontWeight: 600 }
    ],
    'support-h4': [
        '18px',
        { lineHeight: '32px', fontWeight: 600 }
    ],
    'support-h3': [
        '16px',
        { lineHeight: '29px', fontWeight: 600 }
    ],
    'support-h2': [
        '14px',
        { lineHeight: '25px', fontWeight: 600 }
    ],
    'support-h1': [
        '12px',
        { lineHeight: '22px', fontWeight: 600 }
    ],
    'support-p7': [
        '24px',
        { lineHeight: '43px' }
    ],
    'support-p6': [
        '22px',
        { lineHeight: '40px' }
    ],
    'support-p5': [
        '20px',
        { lineHeight: '36px' }
    ],
    'support-p4': [
        '18px',
        { lineHeight: '32px' }
    ],
    'support-p3': [
        '16px',
        { lineHeight: '29px' }
    ],
    'support-p2': [
        '14px',
        { lineHeight: '25px' }
    ],
    'support-p1': [
        '12px',
        { lineHeight: '22px' }
    ],
};
const BODY_FONTS = addFamilyName({
    'body-h9': [
        '28px',
        { lineHeight: '50px', fontWeight: 600 }
    ],
    'body-h8': [
        '26px',
        { lineHeight: '47px', fontWeight: 600 }
    ],
    'body-h7': [
        '24px',
        { lineHeight: '43px', fontWeight: 600 }
    ],
    'body-h6': [
        '22px',
        { lineHeight: '40px', fontWeight: 600 }
    ],
    'body-h5': [
        '20px',
        { lineHeight: '36px', fontWeight: 600 }
    ],
    'body-h4': [
        '18px',
        { lineHeight: '32px', fontWeight: 600 }
    ],
    'body-h3': [
        '16px',
        { lineHeight: '29px', fontWeight: 600 }
    ],
    'body-h2': [
        '14px',
        { lineHeight: '25px', fontWeight: 600 }
    ],
    'body-h1': [
        '12px',
        { lineHeight: '22px', fontWeight: 600 }
    ],
    'body-p7': [
        '24px',
        { lineHeight: '43px' }
    ],
    'body-p6': [
        '22px',
        { lineHeight: '40px' }
    ],
    'body-p5': [
        '20px',
        { lineHeight: '36px' }
    ],
    'body-p4': [
        '18px',
        { lineHeight: '32px' }
    ],
    'body-p3': [
        '16px',
        { lineHeight: '29px' }
    ],
    'body-p2': [
        '14px',
        { lineHeight: '25px' }
    ],
    'body-p1': [
        '12px',
        { lineHeight: '22px' }
    ],
}, 'HYQiHei');
const NUMBER_FONTS = addFamilyName({
    num32: [
        '32px',
        { lineHeight: '48px' }
    ],
    num30: [
        '30px',
        { lineHeight: '44px' }
    ],
    num28: [
        '28px',
        { lineHeight: '42px' }
    ],
    num26: [
        '26px',
        { lineHeight: '38px' }
    ],
    num24: [
        '24px',
        { lineHeight: '36px' }
    ],
    num22: [
        '22px',
        { lineHeight: '32px' }
    ],
    num20: [
        '20px',
        { lineHeight: '28px' }
    ],
    num18: [
        '18px',
        { lineHeight: '26px' }
    ],
    num16: [
        '16px',
        { lineHeight: '24px' }
    ],
    num14: [
        '14px',
        { lineHeight: '20px' }
    ],
    num12: [
        '12px',
        { lineHeight: '18px' }
    ],
    num10: [
        '10px',
        { lineHeight: '15px' }
    ]
}, 'Yuewen Font');
export const fonts = Object.assign(Object.assign(Object.assign({}, NUMBER_FONTS), BODY_FONTS), UI_FONTS);
export const fontWeight = {
    regular: '400',
    medium: '500',
    bold: '600'
};
export const getFontFamilyBases = (assetsResolveType, setupFallbackMedia) => {
    const fontBases = [];
    const getFontPathUrl = (file) => {
        var _a, _b, _c, _d;
        const paths = [];
        const format = SUFFIX_FORMAT_MAP[(_b = (_a = file.match(/\.[^.]+$/)) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : ''];
        const toUrl = url => `url(${url}) format(${format})`;
        const defaultUrl = (_c = urlMap[file][assetsResolveType]) !== null && _c !== void 0 ? _c : urlMap[file][AssetsResolveType.NodeModule];
        paths.push(toUrl(defaultUrl));
        if (assetsResolveType !== AssetsResolveType.CDN && setupFallbackMedia) {
            const backupUrl = (_d = urlMap[file][AssetsResolveType.CDN]) !== null && _d !== void 0 ? _d : '';
            paths.push(toUrl(backupUrl));
        }
        return paths.join(', ');
    };
    for (const [, fontInfo] of fontEntries) {
        fontBases.push({
            '@font-face': {
                'font-family': fontInfo.familyName,
                src: fontInfo.src.map(url => getFontPathUrl(url)).join(',\n')
            }
        });
    }
    return fontBases;
};
